<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PInWjm/tc-custom/9781497620322.jpg?1733033963360" alt="This image is the cover for the book Search for an Abortionist, Forbidden Bookshelf"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Search for an Abortionist, Forbidden Bookshelf
      </h1>
      <p class="bookDescription body article font2">
        <b>This eye-opening look at the abortion process prior to the Supreme Court’s landmark <i>Roe v. Wade</i> decision of 1973 is now more relevant than ever, with a new introduction by the author revisiting history that is still salient half a century later</b><br/><br/>In the years before <i>Roe v. Wade</i>, women seeking to end their unwanted pregnancies had limited options—many of them dangerous, even potentially fatal, and nearly all of them illegal. This groundbreaking work by sociologist Nancy Howell Lee, first published in 1969, takes an intimate look at the entire abortion process—from the initial decision to terminate a pregnancy through the procedure itself and the aftermath—providing an incomparable view of what is still one of the most controversial and divisive issues in America.<br/> <br/>Based on interviews with one hundred fourteen women who had illegal abortions, Howell Lee’s book reveals how the abortions were procured and paid for, and looks at the lasting effects the experience had on the participants. The interviewees were open and honest about what influenced their decisions, how they conducted their search for someone to perform the procedure, and the physical and emotional aftereffects. With many state governments across America currently passing new legislation that restricts and, in many cases, effectively bans abortion, an eventual return to the pre-<i>Roe</i> days threatens the well-being of millions of women, making Nancy Howell Lee’s pioneering study more relevant than ever. It is a must-read for all those interested in reproductive rights issues.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Crispin Miller, Nancy Howell Lee
      </h2>
      
      <p class="authorDescription body article">Nancy Howell Lee, better known as Nancy Howell, is a sociologist and demographer.&#160;Educated at Michigan State, University of Michigan, and Brandeis University, she obtained her PhD from the Harvard University Department of Social Relations in 1968.&#160;Her dissertation was based on the research reported in<I>&#160;The Search for an Abortionist</I>.&#160;She taught in the Department of Sociology at the University of Toronto for thirty years, after brief stints at Wellesley College and Princeton University.&#160;She is a fellow of the anthropology section of the American Association for the Advancement of Science, based on her demographic studies of the !Kung bushmen of the Kalahari Desert.&#160;She is retired from teaching, but continues research and writing. &#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ea2b046